/* yn-pages.js  -  package E: size-guide tabs and remembered-size row, contact form states.
   Plain JavaScript, no libraries. Safe on pages where none of these elements exist. */
(function () {
  'use strict';
  if (window.__ynPages) return;
  window.__ynPages = true;

  var doc = document;

  /* T: the visitor's-language text for a string written in English (Yuno.T comes from yn-head; this falls back to the English). */
  function T(s, p) {
    var f = window.Yuno && window.Yuno.T;
    if (f) return f(s, p);
    s = String(s == null ? '' : s);
    if (p) for (var k in p) s = s.split('[' + k + ']').join(p[k]);
    return s;
  }

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  function reduced() {
    try {
      if (doc.documentElement.classList.contains('yn-reduced')) return true;
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) { return false; }
  }

  function norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s*-\s*/g, '-')
      .replace(/^"+|"+$/g, '')
      .trim();
  }

  /* ---------------------------------------------------------------- remembered size */
  function mySize() {
    try {
      if (window.Yuno && window.Yuno.size && typeof window.Yuno.size.get === 'function') {
        var v = window.Yuno.size.get();
        if (v) return String(v);
      }
    } catch (e) { /* ignore */ }
    try { return window.localStorage.getItem('yuno-age') || ''; } catch (e2) { return ''; }
  }

  function markMine(root) {
    var mine = norm(mySize());
    qsa('tr[data-size]', root).forEach(function (tr) {
      var on = !!mine && norm(tr.getAttribute('data-size')) === mine;
      tr.classList.toggle('is-mine', on);
      var tag = tr.querySelector('[data-yn-sg-mine]');
      if (tag) tag.hidden = !on;
    });
  }

  /* ---------------------------------------------------------------- size guide tabs */
  function initSizeGuide(root) {
    if (!root || root.__ynSg) return;
    root.__ynSg = true;

    var list = root.querySelector('[role="tablist"]');
    var tabs = qsa('[role="tab"]', root);
    if (!list || !tabs.length) { markMine(root); return; }

    function panelOf(tab) { return doc.getElementById(tab.getAttribute('aria-controls')); }

    function select(tab, opts) {
      opts = opts || {};
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = panelOf(t);
        if (!p) return;
        if (on) {
          var wasHidden = p.hidden;
          p.hidden = false;
          if (wasHidden && opts.animate !== false) {
            p.classList.remove('is-in');
            void p.offsetWidth;
            p.classList.add('is-in');
          }
        } else {
          p.hidden = true;
          p.classList.remove('is-in');
        }
      });
      if (opts.focus) tab.focus();
      if (opts.scroll !== false) {
        try { tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { /* ignore */ }
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab); });
    });

    list.addEventListener('keydown', function (ev) {
      var i = tabs.indexOf(doc.activeElement);
      if (i < 0) return;
      var rtl = false;
      try { rtl = window.getComputedStyle(list).direction === 'rtl'; } catch (e) { /* ignore */ }
      var next = -1;
      if (ev.key === 'ArrowRight') next = rtl ? i - 1 : i + 1;
      else if (ev.key === 'ArrowLeft') next = rtl ? i + 1 : i - 1;
      else if (ev.key === 'Home') next = 0;
      else if (ev.key === 'End') next = tabs.length - 1;
      else return;
      ev.preventDefault();
      if (next < 0) next = tabs.length - 1;
      if (next >= tabs.length) next = 0;
      select(tabs[next], { focus: true });
    });

    /* open on ?tab=sets or #sets when it matches a tab */
    var want = '';
    try { want = (new URLSearchParams(window.location.search).get('tab') || '').toLowerCase(); } catch (e3) { /* ignore */ }
    if (!want && window.location.hash) want = window.location.hash.replace(/^#/, '').toLowerCase();
    if (want) {
      for (var k = 0; k < tabs.length; k++) {
        if ((tabs[k].getAttribute('data-key') || '').toLowerCase() === want) {
          select(tabs[k], { animate: false, scroll: false });
          break;
        }
      }
    }
    markMine(root);
  }

  /* ---------------------------------------------------------------- contact form */
  function shake(el) {
    if (!el || !el.animate || reduced()) return;
    var d = 4;
    el.animate([
      { transform: 'translateX(0)' }, { transform: 'translateX(' + (-d) + 'px)' },
      { transform: 'translateX(' + d + 'px)' }, { transform: 'translateX(' + (-d) + 'px)' },
      { transform: 'translateX(' + d + 'px)' }, { transform: 'translateX(0)' }
    ], { duration: 320, easing: 'ease-in-out' });
  }

  function initContact(wrap) {
    if (!wrap || wrap.__ynCon) return;
    wrap.__ynCon = true;

    var form = wrap.querySelector('form');
    if (!form) return;
    var fields = wrap.querySelector('[data-yn-contact-fields]');
    var sent = wrap.querySelector('[data-yn-contact-sent]');
    var err = wrap.querySelector('[data-yn-contact-error]');
    var btn = wrap.querySelector('[data-yn-contact-submit]');
    var email = form.querySelector('[name="contact[email]"]');
    var body = form.querySelector('[name="contact[body]"]');
    var labels = {
      send: btn ? (btn.getAttribute('data-label') || btn.textContent.trim()) : T('Send'),
      sending: btn ? (btn.getAttribute('data-sending') || T('Sending…')) : T('Sending…'),
      noMessage: wrap.getAttribute('data-err-message') || T('Write us a line first'),
      badEmail: wrap.getAttribute('data-err-email') || T('That email looks a little off. Try again?'),
      failed: wrap.getAttribute('data-err-failed') || T("Couldn't send that. Check your connection and try again.")
    };
    var busy = false;

    function setError(msg, field) {
      if (err) err.textContent = msg || '';
      [email, body].forEach(function (f) { if (f) f.setAttribute('aria-invalid', f === field ? 'true' : 'false'); });
      if (msg) {
        shake(form);
        if (field) { try { field.focus(); } catch (e) { /* ignore */ } }
      }
    }

    function setBusy(on) {
      busy = on;
      if (!btn) return;
      btn.disabled = on;
      btn.classList.toggle('is-loading', on);
      btn.textContent = on ? labels.sending : labels.send;
    }

    function showSent() {
      if (fields) fields.hidden = true;
      if (sent) {
        sent.hidden = false;
        wrap.classList.add('is-hop');
        try { sent.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
      setError('');
    }

    [email, body].forEach(function (f) {
      if (!f) return;
      f.addEventListener('input', function () { if (err && err.textContent) setError(''); });
    });

    form.addEventListener('submit', function (ev) {
      if (busy) { ev.preventDefault(); return; }

      /* quick checks first, same wording as the prototype */
      var emailVal = email ? email.value.trim() : '';
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        ev.preventDefault();
        setError(labels.badEmail, email);
        return;
      }
      if (body && !body.value.trim()) {
        ev.preventDefault();
        setError(labels.noMessage, body);
        return;
      }

      /* without fetch the form simply posts the normal way */
      if (!window.fetch || !window.FormData || !window.DOMParser) return;

      ev.preventDefault();
      setError('');
      setBusy(true);

      var started = Date.now();
      window.fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new window.FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      }).then(function (res) {
        /* Shopify's spam check sends people to a challenge page: let the browser do it */
        if (res.url && /\/challenge/.test(res.url)) {
          form.submit();
          return null;
        }
        return res.text();
      }).then(function (html) {
        if (html == null) return;
        var d = new window.DOMParser().parseFromString(html, 'text/html');
        var okNode = d.querySelector('[data-yn-contact-sent]');
        var posted = !!(okNode && !okNode.hasAttribute('hidden'));
        var wait = Math.max(0, 450 - (Date.now() - started));
        window.setTimeout(function () {
          setBusy(false);
          if (posted) {
            showSent();
            form.reset();
          } else {
            var eNode = d.querySelector('[data-yn-contact-error]');
            var msg = eNode ? eNode.textContent.replace(/\s+/g, ' ').trim() : '';
            setError(msg || labels.failed);
          }
        }, wait);
      }).catch(function () {
        setBusy(false);
        setError(labels.failed);
      });
    });
  }

  /* ---------------------------------------------------------------- boot */
  function init(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : doc;
    qsa('[data-yn-sg]', scope).forEach(initSizeGuide);
    qsa('[data-yn-contact]', scope).forEach(initContact);
    if (scope !== doc && scope.matches) {
      if (scope.matches('[data-yn-sg]')) initSizeGuide(scope);
      if (scope.matches('[data-yn-contact]')) initContact(scope);
    }
  }

  function boot() { init(doc); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();

  doc.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
  doc.addEventListener('yuno:size', function () { qsa('[data-yn-sg]').forEach(markMine); });
  doc.addEventListener('yuno:ready', function () { qsa('[data-yn-sg]').forEach(markMine); });
  window.addEventListener('pageshow', function () { qsa('[data-yn-sg]').forEach(markMine); });
})();